import { Link } from "react-router-dom";

export function Wordmark({ className = "", size = "text-3xl", showArrow = false }) {
  return (
    <Link to="/" className={`flex items-center gap-2 select-none ${className}`} data-testid="pas-logo">
      <div className={`pas-wordmark ${size} leading-none`}>
        <div className="pas-gradient-text">PERTH</div>
        <div className="text-white">AUTO SALON</div>
      </div>
      {showArrow && (
        <div className="flex items-center gap-[3px] ml-1">
          <span className="speed-bars h-6">
            <i style={{ height: "60%", alignSelf: "center" }} />
            <i style={{ height: "80%", alignSelf: "center" }} />
            <i style={{ height: "100%", alignSelf: "center" }} />
          </span>
          <svg width="20" height="18" viewBox="0 0 20 18" className="ml-[-2px]">
            <path d="M0 4 L12 4 L12 0 L20 9 L12 18 L12 14 L0 14 Z" fill="url(#g)" transform="skewX(-12)" />
            <defs>
              <linearGradient id="g" x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stopColor="#ffd600" />
                <stop offset="100%" stopColor="#e8321c" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      )}
    </Link>
  );
}
